const CatalogItIcon = ({ size = 256, color = '#FF8F00', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 256 256'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    {/* scales logo down so there is some padding around it */}
    <g transform='translate(32 32) scale(0.75)'>
      <g>
        <path d='M160 80H96V176H160V80Z' style={{ fill: color }} />
      </g>
      <g>
        <path d='M176 192H80V256H176V192Z' style={{ fill: color }} />
      </g>
      <g>
        <path d='M176 0H80V64H176V0Z' style={{ fill: color }} />
      </g>
      <g>
        <path d='M256 176H192V256H256V176Z' style={{ fill: color }} />
      </g>
      <g>
        <path d='M64 176H0V256H64V176Z' style={{ fill: color }} />
      </g>
      <g>
        <path d='M256 0H192V80H256V0Z' style={{ fill: color }} />
      </g>
      <g>
        <path d='M64 0H0V80H64V0Z' style={{ fill: color }} />
      </g>
      <g>
        <path d='M256 96H176V160H256V96Z' style={{ fill: color }} />
      </g>
      <g>
        <path d='M80 96H0V160H80V96Z' style={{ fill: color }} />
      </g>
    </g>
  </svg>
);

export default CatalogItIcon;
